import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=365c6ff2&scoped=true&"
import script from "./EditCompany.vue?vue&type=script&lang=js&"
export * from "./EditCompany.vue?vue&type=script&lang=js&"
import style0 from "./EditCompany.vue?vue&type=style&index=0&id=365c6ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c6ff2",
  null
  
)

export default component.exports